/**
 * Business categories for step 3 ("¿Qué vendes?"). Copy lives in es.json under
 * `SignUpV2.categories.<id>.*` (label, namePlaceholder, pricePlaceholder, tip).
 */
export const PRIMARY_CATEGORIES = [
    { id: 'ropa', icon: 'ri-t-shirt-2-fill' },
    { id: 'belleza', icon: 'ri-sparkling-2-fill' },
    { id: 'tecnologia', icon: 'ri-macbook-fill' },
    { id: 'accesorios', icon: 'ri-vip-diamond-fill' },
    { id: 'comida', icon: 'ri-restaurant-2-fill' },
    { id: 'otro', icon: 'ri-more-fill' },
];

export const MORE_CATEGORIES = [
    { id: 'hogar', icon: 'ri-home-4-fill' },
    { id: 'mascotas', icon: 'ri-bear-smile-fill' },
    { id: 'salud', icon: 'ri-heart-pulse-fill' },
    { id: 'papeleria', icon: 'ri-gift-fill' },
];

export const ALL_CATEGORIES = [...PRIMARY_CATEGORIES, ...MORE_CATEGORIES];

/** Category id used for the product examples when the step was skipped. */
export const DEFAULT_CATEGORY = 'otro';

export const isKnownCategory = (id) => ALL_CATEGORIES.some((category) => category.id === id);

export const isMoreCategory = (id) => MORE_CATEGORIES.some((category) => category.id === id);

/** i18n key for a category field, falling back to the generic examples. */
export const categoryKey = (id, field) =>
    `SignUpV2.categories.${isKnownCategory(id) ? id : DEFAULT_CATEGORY}.${field}`;

/**
 * Store categories (collections) the merchant can pick in the "categorías" step. Multi-select,
 * common ones first then "ver más" / search. Mock list for now (labels inline, es-CO); the real
 * list will come from the backend. Each selected one becomes a storefront category circle.
 */
export const STORE_CATEGORY_OPTIONS = [
    { id: 'ropa', icon: 'ri-t-shirt-line', label: 'Ropa' },
    { id: 'vestidos', icon: 'ri-women-line', label: 'Vestidos' },
    { id: 'calzado', icon: 'ri-footprint-line', label: 'Calzado' },
    { id: 'accesorios', icon: 'ri-vip-diamond-line', label: 'Accesorios' },
    { id: 'bolsos', icon: 'ri-handbag-line', label: 'Bolsos' },
    { id: 'belleza', icon: 'ri-sparkling-2-line', label: 'Belleza' },
    { id: 'deportiva', icon: 'ri-run-line', label: 'Ropa deportiva' },
    { id: 'ninos', icon: 'ri-emotion-happy-line', label: 'Niños' },
    { id: 'hogar', icon: 'ri-home-4-line', label: 'Hogar' },
    { id: 'tecnologia', icon: 'ri-smartphone-line', label: 'Tecnología' },
    { id: 'joyeria', icon: 'ri-vip-crown-line', label: 'Joyería' },
    { id: 'lenceria', icon: 'ri-shirt-line', label: 'Lencería' },
    { id: 'banio', icon: 'ri-sun-line', label: 'Trajes de baño' },
    { id: 'mascotas', icon: 'ri-bear-smile-line', label: 'Mascotas' },
    { id: 'comida', icon: 'ri-restaurant-2-line', label: 'Comida' },
    { id: 'salud', icon: 'ri-heart-pulse-line', label: 'Salud y bienestar' },
    { id: 'papeleria', icon: 'ri-pencil-line', label: 'Papelería' },
    { id: 'otros', icon: 'ri-more-line', label: 'Otros' },
];

/** How many show before "Ver más categorías". */
export const STORE_CATEGORY_PRIMARY_COUNT = 8;

export const getStoreCategory = (id) =>
    STORE_CATEGORY_OPTIONS.find((category) => category.id === id) || null;
